import {APP_LOCAL_STORAGE_OKTA_TOKEN_STORAGE} from 'shared/Storage/constants/localStorageKeys';
import {getQueryValue} from 'utils/links';

const handleQueryParam = (
  queryParamName: 'loginApplePay' | 'sessionToken',
  onValueFound: (value: string | null) => void
) => {
  const searchParams = window.location.search;
  const queryParamValue = getQueryValue(searchParams, queryParamName);

  if (queryParamValue) {
    onValueFound(queryParamValue);
    const params = new URLSearchParams(searchParams);
    params.delete(queryParamName);
    window.history.replaceState({}, '', `${window.location.pathname}?${params}${window.location.hash}`);
  }
};

export const maintainMobileLoginForApplePay = () => {
  handleQueryParam('loginApplePay', () => {
    const event = new CustomEvent('updateToken');
    document.dispatchEvent(event);
  });
};

export const persistTokenFromQueryParam = () => {
  handleQueryParam('sessionToken', (sessionToken: string) => {
    const sessionTokenString = window.atob(sessionToken);
    localStorage.setItem(APP_LOCAL_STORAGE_OKTA_TOKEN_STORAGE, sessionTokenString);
  });
};
